import config from 'src/core/config'
/**
 * 无路由的情况下获取url参数
 * @param name
 * @returns {*}
 */
export const getQueryString = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 匹配目标参数
  var result = window.location.search.substr(1).match(reg)  // 对querystring匹配目标参数
  if (result != null) {
    return decodeURIComponent(result[2])
  } else {
    return null
  }
}

/**
 * 获取缩略图地址
 * @param pic 图片地址
 * @param w 宽
 * @param h 高
 * @param m 模式 0-6 http://wiki.yy.com/index.php/BS2_image%E7%BC%A9%E7%95%A5%E5%9B%BE%E6%8E%A5%E5%8F%A3
 * @param c 裁剪参数
 * @returns {string}
 */
export const thumb = function (pic, w = 0, h = 0, m = 0, c = -1) {
  let queryString = `?ips_thumbnail/${m}`
  if (c > -1) {
    queryString += `/${c}`
  }
  if (w > 0) {
    queryString += `/w/${w}`
  }
  if (h > 0) {
    queryString += `/h/${h}`
  }
  if (!w && !h) {
    queryString = ''
  }
  return `${pic}${queryString}`
}

export const setDocumentTitle = function (title) {
  document.title = title
  const iframe = document.createElement('iframe')
  iframe.style.cssText = 'display: none; width: 0; height: 0;'
  iframe.src = 'https://plx-api.vco.fun'

  const listener = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', listener)
      setTimeout(() => {
        document.body.removeChild(iframe)
      }, 0)
    }, 0)
  }
  iframe.addEventListener('load', listener)
  document.body.appendChild(iframe)
}

export const qiniuCdn = function (path, width = '') {
  let wd = (width !== '') ? '?imageView2/2/w/' + width : ''
  return `${path}${wd}`
}

export const zonets = function () {
  let tz = parseInt(new Date().getTimezoneOffset())
  tz = 480 + tz
  return tz * 60
}


export const transformTime = function (timestamp) {
  if (timestamp && timestamp > 0) {
    var time = new Date(timestamp * 1000);
    var y = time.getFullYear(); //getFullYear方法以四位数字返回年份
    var M = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
    var d = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
    var h = time.getHours(); // getHours方法返回 Date 对象的小时 (0 ~ 23)
    var m = time.getMinutes(); // getMinutes方法返回 Date 对象的分钟 (0 ~ 59)
    var s = time.getSeconds(); // getSeconds方法返回 Date 对象的秒数 (0 ~ 59)
    if (M < 10) {
      M = '0' + M
    }
    if (d < 10) {
      d = '0' + d
    }
    if (h < 10) {
      h = '0' + h
    }
    if (m < 10) {
      m = '0' + m
    }
    if (s < 10) {
      s = '0' + s
    }
    return y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
  } else {
    return '';
  }
}

export const transformTimeDate = function (timestamp, type) {
  if (timestamp && timestamp > 0) {
    var time = new Date(timestamp * 1000);
    var y = time.getFullYear(); //getFullYear方法以四位数字返回年份
    var M = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
    var d = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
    var h = time.getHours(); // getHours方法返回 Date 对象的小时 (0 ~ 23)
    var m = time.getMinutes(); // getMinutes方法返回 Date 对象的分钟 (0 ~ 59)
    var s = time.getSeconds(); // getSeconds方法返回 Date 对象的秒数 (0 ~ 59)
    if (M < 10) {
      M = '0' + M
    }
    if (d < 10) {
      d = '0' + d
    }
    if (h < 10) {
      h = '0' + h
    }
    if (m < 10) {
      m = '0' + m
    }
    if (s < 10) {
      s = '0' + s
    }
    if (type == 2) {
      return y + '.' + M + '.' + d;
    }
    return y + '-' + M + '-' + d;
  } else {
    return '';
  }
}

export const timestampToTime = function (timestamp) {
  var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  return Y + M + D + h + m + s;
}

export const randomWord = function (randomFlag, min, max) {
  let str = "",
    range = min,
    arr = [
      'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
      'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
      'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
      'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',];

  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;// 任意长度
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}

export const getStrCount = function (scrstr, armstr) { //scrstr 源字符串 armstr 特殊字符
  var count = 0;
  while (scrstr.indexOf(armstr) != -1) {
    scrstr = scrstr.replace(armstr, "")
    count++;
  }
  return count;
}

export const transLang = function (la) {
  let str = ""
  switch (la) {
    case 'zh':
      str = '中文'
      break
    case 'en':
      str = '英文'
      break
    case 'ar':
      str = '阿拉伯'
      break
    case 'tr':
      str = '土耳其'
      break
    default:
      break
  }
  return str;
}

export const uploadImg = function (url) {
  let uploadUrl = ""
  if (Array.isArray(url)) {
    if (url.length == 0) {
      uploadUrl = ""
    } else if (url.length > 0) {
      let item = url[url.length - 1]
      if (item && item.uid && item.uid == "-1") {
        uploadUrl = item.url
      } else {
        uploadUrl = url[url.length - 1].response.res.Url
      }
    }
  }
  return uploadUrl
}


// WEBPACK FOOTER //
// ./helper/tool.js